var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
import postTransactionEligible from './postTransactionEligible';
import getRedisputeEligibility from './getRedisputeEligibility';
export var initialState = {
    eligible: false,
    reDisputeEligible: false,
    nonBillingDispute: false,
    caseId: '',
    caseStatus: '',
    caseStatusDescription: '',
    flagIconColor: '',
    backgroundColor: '',
    error: null,
    isCancelSubmitted: true // default to true to not show it unless explicitly told by API that it is false and we need to show it
};
var transactionEligibleSlice = createSlice({
    name: 'transactionEligible',
    initialState: initialState,
    reducers: {
        clearTransactionEligibleState: function () {
            return initialState;
        }
    },
    extraReducers: function (builder) {
        builder.addCase(postTransactionEligible.fulfilled, function (state, action) {
            return __assign(__assign({}, state), action.payload);
        });
        builder.addCase(postTransactionEligible.rejected, function (state, action) {
            return __assign(__assign({}, state), { error: action.payload });
        });
        builder.addCase(getRedisputeEligibility.fulfilled, function (state, action) {
            return __assign(__assign({}, state), action.payload.transactionEligible);
        });
        builder.addCase(getRedisputeEligibility.rejected, function (state, action) {
            return __assign(__assign({}, state), { error: action.payload });
        });
    }
});
export var clearTransactionEligibleState = transactionEligibleSlice.actions.clearTransactionEligibleState;
export default transactionEligibleSlice.reducer;
//# sourceMappingURL=transactionEligible.slice.js.map